import { JSX } from 'react';
import { Box } from '@mui/material';
import { Scrollable } from 'components/Scrollable';
import ResumePreview from 'components/ui/ResumePreview';
import { Resume } from 'types/types';
import { formatDate } from 'utils/formatDate';

function ResumePanelContent({
  resume,
  isMobile,
}: {
  resume: Resume;
  isMobile: boolean;
}): JSX.Element {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: isMobile ? '100%' : '50%',
        maxHeight: '100%',
        p: 0,
        m: 0,
        position: 'relative',
        backgroundColor: '#f5f5f5',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          p: 1,
          fontSize: isMobile ? '0.8rem' : '1rem',
        }}
      >
        <strong>{resume.job?.title}</strong>&nbsp;at&nbsp;<strong>{resume.job?.company}</strong>.
        Last updated {formatDate(resume.updatedAt, false, true)}.
      </Box>
      <Scrollable sx={{ m: 0 }}>
        <ResumePreview shadeMargins={false} resume={resume} />
      </Scrollable>
    </Box>
  );
}

export { ResumePanelContent };
